module.exports = __webpack_public_path__ + "primeicons.71bb3d79dcf18b45ae84.woff";


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/node_modules/primeicons/fonts/primeicons.woff
// module id = ../../../../primeicons/fonts/primeicons.woff
// module chunks = styles